import { Edit, SimpleForm, TextInput, NumberInput } from 'react-admin';

const InputsEdit = (props: any) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source='variableName' required />
      <TextInput source='description' />
      <TextInput source='varType' disabled />
      <TextInput source='tableId' />
    </SimpleForm>
  </Edit>
);

export default InputsEdit;
